export const DESCRIPTION_HEIGHT = {
  DESKTOP: 188,
  MOBILE: 180,
};
